import { makeAction, makeReducer } from '@finn-no/redux-actions';

import isMobile from 'shared/util/mobile.js';
import defaultState from './defaultState.js';
import { getLowfare } from '../polling/server.js';
import { trackCalendarNotAvailable, trackToggleCalendar } from '../tracking/trackLowfare.js';
import {
    hasPriceStats,
    getLowestPrice,
    getLowPriceThreshold,
    getPriceArrayForPeriod,
    getPricesForEarlierPeriod,
    getPricesForLaterPeriod,
    lowfareWithNewPriceAndSearchId,
} from '../lowfare/lowfareUtils.js';

const SLACK = isMobile() ? 1 : 3;

const actions = {};

actions.setCalendarData = makeAction('LOWFARE/SET_CALENDAR_DATA', (state, { payload }) => {
    const returnDate =
        payload.request.requestedReturnDate && payload.request.requestedReturnDate !== '' ? payload.request.requestedReturnDate : null;

    const lowfare = hasPriceStats(payload)
        ? lowfareWithNewPriceAndSearchId(
              payload.lowFares,
              payload.request.requestedDepartureDate,
              returnDate,
              payload.stats.price.min,
              payload.searchId
          )
        : payload.lowFares;

    const priceArray = getPriceArrayForPeriod(lowfare, payload.request.requestedDepartureDate, SLACK);

    return {
        ...state,
        showLowfare: true,
        data: lowfare,
        originalSearch: state.originalSearch.departureDate
            ? state.originalSearch
            : { departureDate: payload.request.requestedDepartureDate, returnDate },
        numberOfDays: { departureDate: payload.request.requestedDepartureDate, returnDate },
        currentPrice: hasPriceStats(payload) ? payload.stats.price.min : null,
        lowestPrice: getLowestPrice(priceArray),
        lowPriceThreshold: getLowPriceThreshold(priceArray),
        earlierPrices: getPricesForEarlierPeriod(lowfare, payload.request.requestedDepartureDate, SLACK),
        laterPrices: getPricesForLaterPeriod(lowfare, payload.request.requestedDepartureDate, SLACK),
        cellsWithPrice: priceArray.length,
    };
});

actions.pollingComplete = () => (dispatch, getState) => {
    if (!getState().lowfare.showLowfare) {
        trackCalendarNotAvailable(getState().request);
    }
    dispatch(actions.setSearching(false));
};

actions.toggleWithTracking = () => (dispatch, getState) => {
    if (!getState().lowfare.showCalendar) {
        trackToggleCalendar(getState().lowfare.cellsWithPrice, getState().request);
    }
    dispatch(actions.toggleCalendar());
};

actions.resetCalendar = makeAction('LOWFARE/RESET_CALENDAR', () => defaultState.lowfare);

actions.toggleCalendar = makeAction('LOWFARE/TOGGLE_CALENDAR', state => ({ ...state, showCalendar: !state.showCalendar }));

actions.setSearching = makeAction('LOWFARE/SET_SEARCHING', 'searching');

actions.setNumberOfDays = makeAction('LOWFARE/SET_NUMBER_OF_DAYS', 'numberOfDays');

actions.setOriginalSearch = makeAction('LOWFARE/SET_ORIGINAL_SEARCH', 'originalSearch');

actions.invokeOtherPeriod = payload => (dispatch, getState) =>
    getLowfare({
        requestedDepartureDate: payload.departureDate,
        requestedReturnDate: payload.returnDate ? payload.returnDate : '',
        requestedOrigin: getState().request.requestedOrigin,
        requestedDestination: getState().request.requestedDestination,
        numberOfAdults: getState().request.numberOfAdults,
        numberOfChildren: getState().request.numberOfChildren,
        lowfareSearchWindow: SLACK,
    }).then(data => {
        const request = {
            requestedDepartureDate: payload.departureDate,
            requestedReturnDate: payload.returnDate,
        };
        dispatch(actions.setCalendarData(Object.assign({}, data, { request })));
        dispatch(actions.setOriginalSearch({ departureDate: payload.departureDate, returnDate: payload.returnDate }));

        return Promise.resolve();
    });

// The default export contains all actions
export default actions;

// The exported reducer handles actions created with plain action creators
export const reducer = makeReducer(actions);
